import BatchForm from "../../components/BatchForm/BatchForm";
const EditBatch = () => {
    return (
        <div style={{ marginTop: '3%' }}>
            <BatchForm type="Edit" />
        </div>
    )
}
export default EditBatch;